import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Updates from './components/Updates';
import Media from './components/Media';
import Ranking from './components/Ranking';
import Carousel from './components/Carousel';
import IndexSection from './components/IndexSection';
import About from './components/About';
import Topics from './components/Topics';
import Comments from './components/Comments';
import Contact from './components/Contact';
import Cards from './components/Cards';
import AppSection from './components/AppSection';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Features />
        <Updates />
        <Media />
        <Ranking />
        <Carousel />
        <IndexSection />
        <About />
        <Topics />
        <Comments />
        <Contact />
        <Cards />
        <AppSection />
        <FAQ />
      </main>
      <Footer />
    </>
  );
}